import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { noop } from 'lodash';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

import LocalTexts from './AccountResultsResetFilters.texts.json';

import styles from './AccountResultsResetFilters.module.scss';

const LocalT = new MDText(LocalTexts);

const AccountResultsResetFilters = ({ onResetFilters = noop }) => (
	<div className={styles.container}>
		<span className={styles.filterAppliedText} {...applyCypressData(cypressIds.text.filtersApplied)}>
			{LocalT.translate('filtersApplied')}
		</span>
		<Hyperlink
			{...applyCypressData(cypressIds.buttons.accountResetFilters)}
			label={LocalT.translate('clearFilters')}
			onClick={onResetFilters}
			variant="primary"
		></Hyperlink>
	</div>
);

AccountResultsResetFilters.propTypes = {
	onResetFilters: PropTypes.func,
};

export default AccountResultsResetFilters;
